module.exports = __webpack_public_path__ + "static/img/linda_planning.ad1abc5.png";